import React from 'react';
import { useStaticQuery, graphql } from 'gatsby';
import SEO from '../components/seo';
import PrivacyIndustryHero from '../components/sections/privacy/privacy-industry-hero';
import AccordionPrivacyFAQ from '../components/sections/privacy/accordion-privacy-faq';
import IndustryPrivacySelector from '../components/sections/privacy/industry-privacy-selector';
import PrivacyButtons from '../components/sections/privacy/privacy-buttons';
import './privacy-industry.css';

const PrivacyNightclubsPage = () => {
  const data = useStaticQuery(graphql`
    query {
      privacyHero: file(relativePath: { eq: "hero-images/privacy-hero.png" }) {
        childImageSharp {
          fluid(quality: 80) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
      privacyFeature: file(relativePath: { eq: "hero-images/privacy_feature.png" }) {
        childImageSharp {
          fluid(maxWidth: 500, quality: 80) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
    }
  `);

  const accordionQuestions = [
    {
      title: 'Is my information going to be used for any other type of communication?',
      response: `
      <p>No, the contact information collected by the guest register is solely for the purposes of contact tracing should Patronscan, or public health officer, need to notify you of a COVID-19 infection risk.
      <br></br>
      With the Patronscan Complete ID scanning package, patrons may be enrolled as members to that establishment only if they provide explicit consent. Members of a particular establishment may be offered event invitations, discount offers or other promotions.</p>`,
    },
    {
      title: 'What information is collected and for what purpose?',
      response: `
      <p>The Patronscan Guest Register collects only your First Name, Last Name, Birthdate and provided contact information (SMS or email). These attributes are used to uniquely identify and contact patrons for COVID-19 contact tracing.
            <br></br>
            Data collected for the guest register is permanently deleted after 30 days. All personal data is held securely using Tier 3 storage facilities and advanced encryption methods.</p>
            `,
    },
    {
      title: 'Who has access to this data?',
      response: `
      <p>Contact information collected by the venue for the guest register is accessible to the venue administrators and may be requested by government agencies for the purposes of public safety.
<br></br>
In case of a major incident concerning public safety or health, government agencies may obtain access to a venues data, but only when an official investigation has been launched. The three conditions in which the agencies may request Patronscan information include:
<br></br>
<div style ="padding-left: 40px;"><span>1. The agency has identified its lawful authority to obtain the information.</span></div>
<div style ="padding-left: 40px;"><span>2. The agency has indicated that the disclosure is requested for the purpose of contact tracing with regards to public health, enforcing a law in its jurisdiction, carrying out an investigation relating to the enforcement of any such law, or gathering intelligence for the purpose of enforcing any such law.</span></div>
<div style ="padding-left: 40px;"><span>3. The agency has provided an investigation number or any other uniquely identifiable number that can be traced back to the purpose of the disclosure request.</span></div>
            `,
    },
    {
      title: 'Does Patronscan adhere to privacy laws in my jurisdiction?',
      response: `
      <p>Patronscan makes every effort to ensure privacy compliance in all jurisdictions in which we operate. In all consultations and investigations, the Patronscan system has been found to comply with all privacy laws in their respective jurisdictions. The guest register feature is not an exception.
            <br></br>
            For our complete Patronscan privacy policy or to request a copy of your information, please visit: <a class="text-blue" href="http://patronscan.com/privacy">https://patronscan.com/privacy</a>.</p>
            `,
    },
    {
      title: 'Does Patronscan share or sell guest register data with third parties?',
      response: `
      No, Patronscan does not share or sell your data to any third parties. In certain cases, Patronscan may be required to provide contact information to approved government agencies for public health and safety purposes. See above for the process government agencies must follow to request this information.</p>
      </p>`,
    },
  ];

  return (
    <div>
      <SEO title="Our Commitment to Privacy - Patronscan" />
      <PrivacyIndustryHero
        heroImage={data.privacyHero.childImageSharp.fluid}
        heading="Privacy Policy"
        subHeading="Guest Registers"
      />
      <h2 className="text-3xl font-hairline font-heading text-grey-dark mb-3 privacy-heading">
        {' '}
        Your Privacy
      </h2>
      <p className="privacy-text">
        Patronscan is committed to protecting people and their privacy. It is our responsibility to
        protect all patron personal information. We comply with all privacy regulations in their
        respective jurisdictions. To learn more about Patronscan's privacy committment, click on the
        questions below.
      </p>
      <div className="privacy-accordion">
        <h2 className="text-3xl font-hairline font-heading text-grey-dark mb-3 privacy-accordion-header">
          Frequently Asked Questions
        </h2>
        <AccordionPrivacyFAQ questions={accordionQuestions} />
      </div>
      <p className="contact-style">
        For any questions that are not answered above, please email us at:{' '}
        <a href="mailto:privacy@patronscan.com" className="text-blue">
          privacy@patronscan.com
        </a>
      </p>
      <PrivacyButtons />
      <IndustryPrivacySelector />
    </div>
  );
};

export default PrivacyNightclubsPage;
